import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaCollectFeePage } from './plaza-collect-fee';

@NgModule({
  declarations: [
    PlazaCollectFeePage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaCollectFeePage),
    TranslateModule.forChild()
  ],
})
export class PlazaCollectFeePageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-collect-fee/plaza-collect-fee.module.ts